import React from 'react';

/**
 * BlobShape, renders an uploaded blob image as a solid, RECOLORABLE shape by
 * using it as a CSS mask over a Tailwind-colored box. The image's own colors are
 * ignored (only its alpha/shape is used), so the blob takes on `colorClass`,  * e.g. `bg-secondary-500`, and follows the design token automatically.
 *
 * Props:
 *   src         blob image URL (svg/png with a transparent background)
 *   colorClass  Tailwind bg-* class for the fill (default: secondary/gold)
 *   className   positioning/size classes for the absolute box
 */
export default function BlobShape({ src, colorClass = 'bg-secondary-500', className = '' }) {
    if (!src) return null;
    const maskStyle = {
        WebkitMaskImage: `url("${src}")`,
        maskImage: `url("${src}")`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
    };
    return (
        <span
            aria-hidden="true"
            className={`pointer-events-none absolute ${colorClass} ${className}`}
            style={maskStyle}
        />
    );
}
